// extracted by mini-css-extract-plugin
export default {"root":"Y2PiQ","section":"QR5LQ","label":"_9cxWP"};